"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightSeparator = exports.LeftSeparator = void 0;

var _react = _interopRequireDefault(require("react"));

var s = _interopRequireWildcard(require("./PaginationBreadcrumbs.style"));

var LeftSeparator = function LeftSeparator(_ref) {
  var firstPage = _ref.firstPage,
      leftMost = _ref.leftMost,
      theme = _ref.theme,
      isDarkTheme = _ref.isDarkTheme;
  if (leftMost <= firstPage + 1) return null;
  return _react.default.createElement("div", {
    className: s.separator(theme, isDarkTheme)
  }, "\u2022\u2022\u2022");
};

exports.LeftSeparator = LeftSeparator;

var RightSeparator = function RightSeparator(_ref2) {
  var rightMost = _ref2.rightMost,
      lastPage = _ref2.lastPage,
      theme = _ref2.theme,
      isDarkTheme = _ref2.isDarkTheme;
  if (rightMost >= lastPage - 1) return null;
  return _react.default.createElement("div", {
    className: s.separator(theme, isDarkTheme)
  }, "\u2022\u2022\u2022");
};

exports.RightSeparator = RightSeparator;